export const formatProfitabilityMoney = (value: number | null | undefined): string => {
  const amount = typeof value === 'number' && Number.isFinite(value) ? value : 0;
  return `${amount.toFixed(2)} грн`;
};

export const formatProfitabilityMargin = (value: number | null | undefined): string => {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return '—';
  }

  return `${value.toFixed(1)}%`;
};

export const getProfitabilityBasisLabel = (basis: string | null | undefined): string => {
  if (basis === 'inventoryWriteOffEstimate') {
    return 'Списання за партіями / поточною собівартістю';
  }

  if (basis === 'plannedMenuCost') {
    return 'Планова собівартість меню';
  }

  return 'Невідоме джерело';
};

export const getProfitabilityStatusLabel = (hasCompleteCostData: boolean): string =>
  hasCompleteCostData ? 'Підтверджено' : 'Попередньо';
